"use client";

import { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

export default function NewsAndEventsPage() {
  const [selectedEvent, setSelectedEvent] = useState(null);

  const events = [
    {
      title: "Vigil Mass",
      start: "2026-09-03",
      backgroundColor: "#2563eb",
      borderColor: "#2563eb",
      extendedProps: {
        description:
          "7.00pm St Edmund of Canterbury L22 8QF.\n Bishop Tom Neylon will be principal celebrant. \n We are so shocked and saddened by the sudden death of Fr Joe Kendall, at the age of 45. Fr Joe was most recent serving in Valladolid, Spain, where he was Vice-Rector at the Royal English College. Our thoughts and prayers go out to his siblings, his wider family and friends, the Valladolid Community and his brother priests at this time. \n May Fr Joe rest in peace and rise in glory. \n Fr Anthony. \n Please pray for the repose of the soul of Fr. Joe."
      },
    },
    {
      title: "Requiem Mass",
      start: "2026-09-04",
      backgroundColor: "#2563eb",
      borderColor: "#2563eb",
      extendedProps: {
        description:
          "12 noon Metropolitan Cathedral of Christ the King.\n The Archbishop will be the principal celebrant. \n We are so shocked and saddened by the sudden death of Fr Joe Kendall, at the age of 45. Fr Joe was most recent serving in Valladolid, Spain, where he was Vice-Rector at the Royal English College. Our thoughts and prayers go out to his siblings, his wider family and friends, the Valladolid Community and his brother priests at this time. \n May Fr Joe rest in peace and rise in glory. \n Fr Anthony. \n Please pray for the repose of the soul of Fr. Joe."
      },
    },
    {
      title: "Eucharistic Ministers Meeting",
      start: "2026-09-16",
      backgroundColor: "#2563eb",
      borderColor: "#2563eb",
      extendedProps: {
        description:
          "6.00pm in the Community Room"
      },
    },
    {
      title: "Parish council Meeting",
      start: "2026-09-24",
      backgroundColor: "#2563eb",
      borderColor: "#2563eb",
      extendedProps: {
        description:
          "7.00pm in the Community Room"
      },
    },
    {
      title: "Christmas Party",
      start: "2026-11-27T19:30:00",
      backgroundColor: "#b91c1c",
      borderColor: "#b91c1c",
      extendedProps: {
        description:
          "7.30pm at Our Lady Queen of Martyrs Parish Club.\n Our Lady Queen of Martyrs and St Swithin's Christmas Party. \n Cost £5. \n Tickets on sale at all weekend masses.",
        image: "/pictures/christmas-poster.png",
      },
    },
  ];

  return (
    <div className="min-h-screen bg-white p-8">
      <h1 className="text-4xl font-bold text-center text-black mb-8">
        News and Events
      </h1>

      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        height="750px"
        events={events}
        eventDisplay="block"
        displayEventTime={false}
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "",
        }}
        eventClick={(info) => {
          setSelectedEvent({
            title: info.event.title,
            description: info.event.extendedProps.description,
            image: info.event.extendedProps.image,
          });
        }}
      />
      {selectedEvent && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 text-center max-h-[90vh] overflow-y-auto">

            {selectedEvent.image && (
              <img
                src={selectedEvent.image}
                alt={selectedEvent.title}
                className="w-full rounded mb-4"
              />
            )}

            <h2 className="text-2xl font-semibold text-black mb-4">
              {selectedEvent.title}
            </h2>

            <p className="text-black whitespace-pre-line mb-6 leading-relaxed">
              {selectedEvent.description}
            </p>

            <button
              onClick={() => setSelectedEvent(null)}
              className="border border-black text-black px-4 py-1 rounded hover:bg-black hover:text-white transition"
            >
              Close
            </button>

          </div>
        </div>
      )}
    </div>
  );
}